import { openConfirmDialog } from '../useDialog'
import { i18n } from '../../localization'
import { ApiCryptoWalletRequest } from '../api'
import { ProfileTypes } from '../../typings'

export enum SimplyTokenizedRedirectStatus {
    Success = 'success',
    Error = 'error',
}

export function handleSimplyTokenizedRedirects() {
    const url = new URL(window.location.href)
    const status = url.searchParams.get('simplytokenized_status')
    if (status === SimplyTokenizedRedirectStatus.Success) {
        openConfirmDialog(
            i18n.global.t('crypto_wallet.success_dialog_title'),
            i18n.global.t('crypto_wallet.success_dialog_description'),
            { type: 'Success', hideCancel: true, confirmText: i18n.global.t('crypto_wallet.success_dialog_button') }
        )
    } else if (status === SimplyTokenizedRedirectStatus.Error) {
        openConfirmDialog(
            i18n.global.t('crypto_wallet.error_dialog_title'),
            i18n.global.t('crypto_wallet.error_dialog_description'),
            { type: 'Error', hideCancel: true, confirmText: i18n.global.t('crypto_wallet.error_dialog_button') }
        )
    }
}

export function generateCryptoWalletRequestBody(type: ProfileTypes, profileId: string): ApiCryptoWalletRequest {
    const requestBody = {
        profile_type: type,
        success_url:
            window.location.href.split('?')[0] + '?simplytokenized_status=' + SimplyTokenizedRedirectStatus.Success,
        error_url:
            window.location.href.split('?')[0] + '?simplytokenized_status=' + SimplyTokenizedRedirectStatus.Error,
    }

    if (type === 'natural') {
        requestBody['natural_profile_id'] = profileId
    } else {
        requestBody['legal_profile_id'] = profileId
    }

    return requestBody
}
